import { EventTypes, track, getPageSource } from '@mc/track-event'

interface TrackEmailCaptureProps {
  email: string
  location?: string
  campaign?: string
  contentType?: string
  slug?: string
  category?: string
}

export const trackEmailCapture = ({
  email,
  location,
  campaign = 'sample',
  contentType,
  slug,
  category,
}: TrackEmailCaptureProps) => {
  track(
    EventTypes.EMAIL_CAPTURED,
    {
      campaign,
      email,
      location,
      contentType,
      slug,
      type: 'email',
      platform: 'web',
      category,
      page_source: getPageSource(),
    },
    { integrations: { Iterable: true } },
  )
}
